import { observer } from 'mobx-react-lite';
import { Alert, Spinner } from 'react-bootstrap';

import TreeView from 'components/TreeView/TreeView';
import { type WorkspaceModel } from './WorkspaceModel';
import { type WorkspaceTreeNode } from './WorkspaceTreeModel';
import { WorkspaceItemLabelFor } from './WorkspaceItemLabelFor';

const renderLabel = (node: WorkspaceTreeNode) =>
  node.isLoadingPlaceholder ? (
    <span className="workspace-tree-loading text-body-tertiary">
      <Spinner animation="border" size="sm" /> Loading…
    </span>
  ) : (
    <WorkspaceItemLabelFor item={node.item} />
  );

/** The container tree (zones → folders). Pure observer over WorkspaceTreeModel. */
export const WorkspaceTree = observer(({ model }: { readonly model: WorkspaceModel }) => {
  const { tree } = model;

  if (tree.rootsLoading) {
    return (
      <div className="p-3 text-body-tertiary">
        <Spinner animation="border" size="sm" /> Loading zones…
      </div>
    );
  }
  if (tree.error && tree.roots.length === 0) {
    return (
      <Alert variant="danger" className="m-2">
        {tree.error}
      </Alert>
    );
  }

  return (
    <TreeView<WorkspaceTreeNode, string>
      className="workspace-tree"
      roots={tree.roots}
      getId={tree.getId}
      getChildren={tree.getChildren}
      renderLabel={renderLabel}
      expandedIds={tree.expandedIds}
      onToggle={tree.toggle}
      selectedId={model.selected ?? undefined}
      onSelect={model.selectNode}
      hasChildren={tree.hasChildren}
    />
  );
});
